import React, { useCallback } from 'react';
import { View } from 'react-native';
import { Button, Spacer } from 'design-system';
import ModalHandle from 'design-system/ModalHandle';
import Text from 'design-system/Text';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import Modal from 'utils/packages/Modal';
const strings = {
    pauseAndSkip: 'Pause & skip payment',
    pause: 'Pause',
    cancel: 'Cancel',
};
export const AutosavePauseModalContent = ({ title, subtitle, onPauseAndSkip, onPause, }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const handlePauseAndSkip = useCallback(() => {
        Modal.hide();
        onPauseAndSkip();
    }, [onPauseAndSkip]);
    const handlePause = useCallback(() => {
        Modal.hide();
        onPause();
    }, [onPause]);
    const handleCancel = useCallback(() => {
        Modal.hide();
    }, []);
    return (<View style={[styles.container, { backgroundColor: colors.cards.onDark }]}>
      <ModalHandle />
      <Text Text-20 centered>
        {title}
      </Text>
      {subtitle ? (<>
          <Spacer h={16}/>
          <Text TextThin-14 Gray centered>
            {subtitle}
          </Text>
        </>) : null}
      <Spacer h={24}/>
      <Button brandBorder title={strings.pauseAndSkip} onPress={handlePauseAndSkip}/>
      <Spacer h={8}/>
      <Button brandReversed title={strings.pause} onPress={handlePause}/>
      <Spacer h={8}/>
      <Button brand title={strings.cancel} onPress={handleCancel}/>
    </View>);
};
const AutosavePauseModal = {
    show: ({ title, subtitle, onPauseAndSkip, onPause }) => {
        Modal.show(<AutosavePauseModalContent title={title} subtitle={subtitle} onPauseAndSkip={onPauseAndSkip} onPause={onPause}/>, { containerStyle: styles.modal });
    },
    hide: () => {
        Modal.hide();
    },
};
export default AutosavePauseModal;
const styles = { modal: { paddingHorizontal: 0, overflow: 'hidden' } };
const styleSet = createStyleSheets(() => ({
    container: {
        paddingHorizontal: 16,
        paddingTop: 28,
        paddingBottom: 16,
    },
}));
